var rich_content_viewer_default = {
  "fontElementMap": "TGZiG",
  "wrapper": "_0lFkY",
  "pluginContainerMobile": "-Tbft",
  "viewer": "HBUKN",
  "android": "HSwZJ",
  "rootedTraversedContent": "QZjby",
  "atomic": "_-8c8m",
  "toolbar": "HvgnF",
  "block": "_0uqgT"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
